import { render, staticRenderFns } from "./softwareStep04.vue?vue&type=template&id=6fefc0c9&"
import script from "./softwareStep04.vue?vue&type=script&lang=js&"
export * from "./softwareStep04.vue?vue&type=script&lang=js&"
import style0 from "./softwareStep04.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports